import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import strings from "../../config/localization";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useNavigate, useParams } from "react-router-dom";
import { useAddRoleMutation, useGetRolesQuery } from "../../services/appln";
import Grid from "@mui/material/Grid";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import SearchButton from "../../components/Buttons/SearchButton";
import { Typography } from "@mui/material";
import { getRowsPerPage } from "../constants";

export default function RoleSelectionPanel() {
  const navigate = useNavigate();
  const { userId } = useParams();

  const [addRole, addRoleParams] = useAddRoleMutation();
  console.log(addRoleParams);

  if (addRoleParams.isSuccess) {
    navigate(-1);
  }

  const [count, setCount] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(getRowsPerPage());

  const [selectedRowIDs, setSelectedRowIDs] = useState(new Set());
  const [searchTerm, setSearchTerm] = React.useState("");

  const getParams = {
    userId: userId,
    page: count,
    limit: rowPerPage,
    search: searchTerm,
  };

  const { data, error, isLoading, isFetching } = useGetRolesQuery(getParams);

  const columns = [
    {
      field: "name",
      headerName: strings.name,
      width: 200,
    },
  ];

  const handleChangePage = (event: any, value: any) => {
    setCount(value);
  };

  const handleChangeCount = (e: any) => {
    setRowPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom component="div">
              {" "}
              {strings.selectRoles}{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {isLoading || isFetching || addRoleParams.isLoading ? (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : null}
          </Grid>
          {error ? (
            <Grid item xs={12}>
              <Alert severity="error">
                <AlertTitle>{strings.error}</AlertTitle>
                {strings.failedToLoadRoles}
              </Alert>
            </Grid>
          ) : null}
          <Grid item xs={10}>
            <SearchButton
              onClickHandler={(searchTerm: string) => {
                setCount(1);
                setSearchTerm(searchTerm);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={data?.data ? data?.data : []}
                columns={columns}
                checkboxSelection={true}
                onRowSelectionModelChange={(e) => {
                  const ids = new Set();
                  e.forEach((element: unknown) => {
                    ids.add(element);
                  });
                  setSelectedRowIDs(ids);
                }}
              />
              <CommonPagination
                count={Math.ceil(data?.totalCount / rowPerPage)}
                page={count}
                handleChangePage={handleChangePage}
                rowPerPage={rowPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={(e) => {
                addRole({
                  userId: userId,
                  roleIds: Array.from(selectedRowIDs),
                });
                navigate(-1);
              }}
            >
              {strings.select}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
